import { Step } from "types/steps";
import { api } from "./api";
import { dedupedFetch } from "./cache";

const fetchSteps = async (): Promise<Step[]> => {
  return dedupedFetch("steps", async () => {
    const { data } = await api.get("/database/etapas__c");
    return data;
  }, 120_000);
};

export { fetchSteps };
